import { supabase } from '@/lib/supabase';

/** Untyped until database.generated.ts is regenerated with LPR tables. */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const lpr = supabase as any;

export type LprForloebStatus = 'draft' | 'ready' | 'reported';
export type LprSubmissionStatus = 'simulated' | 'queued' | 'sent' | 'accepted' | 'rejected';
export type LprDiagnoseArt = 'aktion' | 'bi';

export interface LprSksCode {
  code: string;
  list: string;
  label_da: string;
  label_en: string;
  sort_order: number;
  is_active: boolean;
}

export interface ClinicLprSettings {
  clinic_id: string;
  sor_id: string | null;
  default_forloebslabel: string;
  default_henvisningsmaade: string;
  default_frit_valg: string;
  default_kontakt_type: string;
  default_betaling: string;
  created_at: string;
  updated_at: string;
}

export interface LprForloeb {
  id: string;
  clinic_id: string;
  patient_id: string;
  referral_id: string | null;
  object_id: string;
  sor_id: string | null;
  start_at: string;
  end_at: string | null;
  forloebslabel: string;
  henvisningstidspunkt: string;
  henvisningsmaade: string;
  frit_valg: string;
  henvisende_instans_sor: string | null;
  afslutningsmaade: string | null;
  notes: string | null;
  status: LprForloebStatus;
  created_by_user_id: string | null;
  created_at: string;
  updated_at: string;
}

export interface LprKontakt {
  id: string;
  clinic_id: string;
  forloeb_id: string;
  appointment_id: string | null;
  object_id: string;
  kontakt_type: string;
  start_at: string;
  end_at: string;
  ansvarlig_sor: string | null;
  betaling: string;
  notes: string | null;
  created_at: string;
  updated_at: string;
}

export interface LprDiagnose {
  id: string;
  clinic_id: string;
  kontakt_id: string;
  art: LprDiagnoseArt;
  sks_code: string;
  sks_text: string | null;
  created_at: string;
}

export interface LprProcedure {
  id: string;
  clinic_id: string;
  kontakt_id: string;
  sks_code: string;
  sks_text: string | null;
  performed_at: string | null;
  created_at: string;
}

export interface LprSubmission {
  id: string;
  clinic_id: string;
  forloeb_id: string;
  version_number: number;
  status: LprSubmissionStatus;
  payload: Record<string, unknown>;
  error_text: string | null;
  created_by_user_id: string | null;
  created_at: string;
}
